import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';

/**
 * 회원탈퇴 안내 문구
 * @constructor
 */
function CommentSection() {
    const { t } = useTranslation('accountTermination');
    return (
        <Container as='section' spacing={6}>
            <Text size='display'
                fontWeight='bold' >
                {t('comment.title')}
            </Text>
            <Text color={colors.gray7}>
                <Trans ns='accountTermination'
                    i18nKey='comment.description'
                    components={{ br: <br/> }} />
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 48px 0 36px;
`;

export default CommentSection;
